"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DialFinger1: ['dial-finger-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.875,1.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,1.875,1.5h0', 'M7.125 1.5L7.125 1.5', 'M7.125,1.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,7.125,1.5', 'M12.375 1.5L12.375 1.5', 'M12.375,1.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M1.875 6.75L1.875 6.75', 'M1.875,6.75a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M7.125 6.75L7.125 6.75', 'M7.125,6.75a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M1.875 12L1.875 12', 'M1.875,12a.375.375,0,1,0,.375.375A.375.375,0,0,0,1.875,12', 'M7.125 12L7.125 12', 'M7.125,12a.375.375,0,1,0,.375.375A.375.375,0,0,0,7.125,12', 'M6.75,22.5l-1.9-3.327A2.263,2.263,0,0,1,8.7,16.8l1.8,2.7V8.25a2.25,2.25,0,0,1,4.5,0V16.5h3.379A4.332,4.332,0,0,1,22.5,20.847V22.5']],
  DialPad: ['dial-pad', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 3.000 A2.250 2.250 0 1 0 5.250 3.000 A2.250 2.250 0 1 0 0.750 3.000 Z', 'M9.750 3.000 A2.250 2.250 0 1 0 14.250 3.000 A2.250 2.250 0 1 0 9.750 3.000 Z', 'M18.750 3.000 A2.250 2.250 0 1 0 23.250 3.000 A2.250 2.250 0 1 0 18.750 3.000 Z', 'M0.750 12.000 A2.250 2.250 0 1 0 5.250 12.000 A2.250 2.250 0 1 0 0.750 12.000 Z', 'M9.750 12.000 A2.250 2.250 0 1 0 14.250 12.000 A2.250 2.250 0 1 0 9.750 12.000 Z', 'M18.750 12.000 A2.250 2.250 0 1 0 23.250 12.000 A2.250 2.250 0 1 0 18.750 12.000 Z', 'M9.750 21.000 A2.250 2.250 0 1 0 14.250 21.000 A2.250 2.250 0 1 0 9.750 21.000 Z']]
};
exports["default"] = _default;